import { Component, OnInit } from '@angular/core';
import { TransactionsService } from '../../../../../resources/transactions/transactions.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as moment from 'moment';
import { Transaction } from '../../../../../model/transaction';


type Base = ('months' | 'weeks' | 'days' );

enum ranges {
  days = '1 dzień',
  weeks = '1 tydzień',
  months = '1 miesiąc',
}

@Component({
  selector:    'app-last-transactions',
  templateUrl: './last-transactions.component.html',
  styleUrls:   [ './last-transactions.component.scss' ]
})
export class LastTransactionsComponent implements OnInit {

  range: string;
  transactions: Transaction[];
  loading = true;
  p = 0;

  private range$ = new BehaviorSubject('days');


  constructor(private transactionsService: TransactionsService) {
  }

  ngOnInit() {
    this.range$.asObservable()
      .do(() => this.loading = true)
      .switchMap((range: Base) => {
        this.range = ranges[ range ].toString();
        return this.transactionsService.query(null, {
          start: moment().subtract(1, range).format('YYYY-MM-DD'),
          end:   moment().format('YYYY-MM-DD')
        });
      })
      .subscribe((data) => {
        this.transactions = data;
        this.loading = false;
      });
  }


  changeRange(range) {
    this.range$.next(range);
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/stats/last-transactions/last-transactions/last-transactions.component.ts